import {useState} from 'react';

export function ModifTitre ({auth, updateUsercontext, action, title, consigne}) {

  const [newTitle, setNewTitle] = useState(title || auth.field_title)
  const [newConsigne, setNewConsigne] = useState('')

const style = {
    color:'teal',
    display:'block',
    border:'3px solid lightcoral',
    borderRadius:'5px',
    padding:'5px',
    margin:'10px 0px',
    fontSize:'0.9em',
  }

const handleChange = (e) => {
  if(e.target.name === 'title') {
    setNewTitle(e.target.value)
  }
  if(e.target.name === 'consigne') {
    setNewConsigne(e.target.value)
  }  
}

const handleTitle = (e) => {
  let theme = auth.field_title.replace('2e devoir mêmes notions__', '').replace('3e devoir mêmes notions__', '')
  if(theme.includes('__')) {
    theme = theme.split('__')[0]
  }
  if(theme.includes('/')) {
    theme = theme.split('/')[1]
  }
  setNewTitle(theme)
}
const handleClick = (e) => {
  fetch("https://maths-au-quotidien.fr/react-automaths/api-database.php", {
      method: 'POST',
      body: JSON.stringify({...auth, action:'modif_titre', field_content:newTitle, consigne:newConsigne})
    })
    .then(response => response.json())
    .then(data => {
      //console.log(data)
      updateUsercontext()
      action()
    })
    .catch(err => console.log(err))
}

  //console.log(auth)
  return (
    <div className="mofifTitreCadre" style={style}>
      <b>Modifier le titre ou la consigne</b><br/><br/>
    	<input name='title' value={newTitle || title} onChange={handleChange} size="10" placeholder='Nouveau titre'/>
      <span name="modif_titre" style={{paddingLeft:'5px', cursor:'pointer'}} onClick={handleTitle}>🖊</span>

      <input name='consigne' value={newConsigne || consigne} onChange={handleChange} style={{color:'teal'}} size="10" placeholder='Consigne' />

    {
      (newTitle && newTitle.length > 1) && 
      <div align="center">
        <input className="btn standard" name="devoir_send" type="button" value="Modifier" onClick={handleClick}/>
      </div>
    }
    </div>
  );
}